import type { Locale } from "../Locale.js";
import type { Subcategory } from "../Subcategory.js";
import { getCategoryPath } from "./getCategoryPath.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getSubcategoryPath(
	locale: Locale,
	subcategory: Pick<Subcategory, "category" | "urlSlug" | "useCustomUrlSlug">,
): string {
	if (subcategory.useCustomUrlSlug[locale]) {
		return getPathInLocale(locale, `/${subcategory.urlSlug[locale]}`);
	}

	return `${getCategoryPath(locale, subcategory.category)}/${subcategory.urlSlug[locale]}`;
}
